<template>
    <b-container>
        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="name"
                    label="<strong>Nombre *</strong>">
                    <b-form-input
                        id="name"
                        type="text"
                        placeholder="Nombre"
                        v-model="client.name">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="surname"
                    label="<strong>Apellidos *</strong>">
                    <b-form-input
                        id="surname"
                        type="text"
                        placeholder="Apellidos"
                        v-model="client.surname">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label="<strong>Sexo *</strong>"
                    label-for="sex">
                    <multiselect
                        id="sex"
                        v-model="client.sex"
                        :allow-empty="false"
                        :options="sexes.map(type => type.value)"
                        :custom-label="opt => sexes.find(x => x.value === opt).text"
                        selectedLabel=""
                        selectLabel=""
                        deselectLabel=""
                        placeholder="Seleccione"></multiselect>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label="<strong>Fecha de Nacimiento</strong>"
                    label-for="birthday">
                    <v-date-picker
                        id="birthday"
                        v-model="client.birthday"
                        :max-date="new Date()"
                        class="date-picker-w-100 date-picker-custom-border">
                    </v-date-picker>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="nif"
                    label="<strong>NIF</strong>">
                    <b-form-input
                        id="nif"
                        v-model="client.nif"
                        type="text"
                        placeholder="NIF"
                        :state="nifState">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <!-- Teléfonos !-->
                <b-form-group
                    label="<strong>Teléfonos *</strong>"
                    label-for="phone"
                    :horizontal="false"
                    class="w-100  mb-0">
                    <b-form-input
                        id="phone"
                        name="phone"
                        type="text"
                        placeholder="Introduzca Teléfono y pulse intro"
                        class="w-100"
                        @keypress.enter.native.prevent="addPhone($event.target.value)"
                        v-validate="getValidateRulesForArrayField('phones', {required: true, phone: true})"
                        aria-describedby="check_phone"
                        v-model="phone"
                        :state="validateState('phone')"
                        autocomplete="nope">
                    </b-form-input>
                    <div class="text-danger text-right" id="check_phone">
                        <small>{{ errors.first('phone') }}</small>
                    </div>
                </b-form-group>
                <b-list-group>
                    <b-list-group-item v-for="(phone,index) in client.phones" :key="index">
                        {{ phone.phone }}
                        <div @click="removePhone(phone.phone)">
                            <template>
                                <b-badge variant="danger" class="float-left" pill>
                                    Borrar
                                </b-badge>
                            </template>
                        </div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="email"
                    label="<strong>Email</strong>">
                    <b-form-input
                        id="email"
                        v-model="client.email"
                        type="text"
                        placeholder="Email"
                        :state="emailState">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <location-form
            :community-required="true"
            :province-required="true"
            @community-change="community => {client.address.community = community}"
            @province-change="province => {client.address.province = province}"
            @town-change="town => {client.address.town = town}"
            @postal-code-change="postalCode => {client.address.postalCode = postalCode}"
            @address-change="address => {client.address.address = address}"></location-form>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label="<strong>Modelo de Gestión</strong>"
                    label-for="managementModel">
                    <multiselect
                        id="managementModel"
                        v-model="client.managementModel"
                        :options="managementModels.map(option => option.value)"
                        :customLabel="value => (managementModels.find(option => option.value === value).text)"
                        :multiple="false"
                        :allowEmpty="true"
                        placeholder="Seleccione"
                        selectedLabel=""
                        selectLabel=""
                        deselectLabel="">
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label="<strong>Actividades CNAE</strong>"
                    label-for="cnaes">
                    <multiselect
                        id="cnaes"
                        v-model="client.cnaes"
                        :options="cnaes"
                        label="activity"
                        track-by="uuid"
                        :multiple="true"
                        :allowEmpty="false"
                        placeholder="Seleccione"
                        selectedLabel=""
                        selectLabel=""
                        deselectLabel="">
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="companyName"
                    label="<strong>Nombre de Empresa</strong>">
                    <b-form-input
                        id="companyName"
                        type="text"
                        placeholder="Nombre de la Empresa"
                        v-model="client.company.name">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="companyCif"
                    label="<strong>CIF de Empresa</strong>">
                    <b-form-input
                        id="companyCif"
                        v-model="client.company.cif"
                        type="text"
                        placeholder="CIF de la Empresa"
                        :state="companyCifState">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="companyWorkers"
                    label="<strong>Número de Trabajadores de la Empresa</strong>">
                    <b-form-input
                        id="companyWorkers"
                        type="number"
                        placeholder="Número de Trabajadores de la Empresa"
                        v-model="client.company.numberOfWorkers">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col xs="12" class="d-flex flex-row-reverse">
                <button
                    v-if="renderSaveButton"
                    class="btn btn-brand btn-primary btn-lg"
                    :disabled="!formValid"
                    @click="submitClient">
                    <slot></slot>
                </button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import Multiselect from 'vue-multiselect';
    import {getManagementModelsOptions, getClientSexesOptions} from '@/helpers/client-helper';
    import form from '@/helpers/form';
    import LocationForm from '@/components/location/LocationForm';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: "client-form",
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            LocationForm
        },
        props: [
            'cnaes',
            'renderSaveButton'
        ],
        data: function () {
            return {
                client: {
                    name: null,
                    surname: null,
                    sex: null,
                    address: {
                        name: null,
                        address: null,
                        town: null,
                        postalCode: null,
                        province: null,
                        main: null
                    },
                    phones: [],
                    email: null,
                    birthday: null,
                    nif: null,
                    managementModel: null,
                    company: {
                        cif: null,
                        name: null,
                        numberOfWorkers: null
                    },
                    cnaes: []
                },
                phone: '',
            };
        },
        computed: {
            nifState() {
                if (!!this.client.nif) {
                    return form.validateNIF(this.client.nif);
                } else {
                    return null;
                }
            },
            companyCifState() {
                if (!!this.client.company.cif) {
                    return form.validateCIF(this.client.company.cif);
                } else {
                    return null;
                }
            },
            emailState() {
                if (!!this.client.email) {
                    return form.email(this.client.email);
                } else {
                    return null;
                }
            },
            formValid() {
                return (
                    !!this.client.name
                    && !!this.client.surname
                    && !!this.client.sex
                    && !!this.client.phones
                    && !!this.client.address.province
                    && (this.emailState === null || this.emailState === true)
                    && (this.nifState === null || this.nifState === true)
                    && (this.companyCifState === null || this.companyCifState === true)
                );
            },
            managementModels() {
                return getManagementModelsOptions();
            },
            sexes() {
                return getClientSexesOptions();
            }
        },
        methods: {
            store(e) {
                if (e.preventDefault()) {
                    return;
                }

                let self = this;
                this.$_loadingMixin_showLoading();
                if (this.validateState('phone')) {
                    this.addPhone(this.phone);
                }
            },
            addPhone(number) {
                if (form.phone(number)) {
                    this.client.phones.push({phone: number})
                    this.phone = ""
                }
            },
            removePhone(phone) {
                this.client.phones = this.client.phones.filter(function (e) {
                    return e.phone !== phone
                })
            },
            getValidateRulesForArrayField(entityProp, rules) {
                if (this.client[entityProp] && this.client[entityProp].length && rules.hasOwnProperty('required')) {
                    delete rules.required;
                }

                return rules;
            },
            submitClient() {
                if (this.renderSaveButton) {
                    this.$emit('submit-client', this.client);
                }
            }
        }
    }
</script>

<style scoped>

</style>